// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Router from "next/router";
import * as AuthStore$PorterinFeature from "../../../../domain/store/AuthStore.mjs";
import * as CityContext$PorterinFeature from "../../../../../../contexts/city-context/CityContext.mjs";
import * as AuthInputCmp$PorterinFeature from "../../common/AuthInputCmp.mjs";
import * as CommonHelper$PorterinFeature from "../../../../../../shared/core/helpers/CommonHelper.mjs";
import * as AuthButtonCmp$PorterinFeature from "../../common/AuthButtonCmp.mjs";
import * as AuthContextV1$PorterinFeature from "../../../../view-model/contexts/auth-context/AuthContextV1.mjs";
import * as LoginFormState$PorterinFeature from "./LoginFormState.mjs";
import * as LoginFormUtils$PorterinFeature from "../../../../domain/helpers/LoginFormUtils.mjs";
import * as LoginFormInterface$PorterinFeature from "./LoginFormInterface.mjs";
import * as LoginFormModuleScss from "../../../styles/LoginForm.module.scss";

var styles = LoginFormModuleScss;

function LoginFormCmp(Props) {
  var set_auth_state = Props.set_auth_state;
  var set_is_input_in_focus = Props.set_is_input_in_focus;
  var login_form_stateOpt = Props.login_form_state;
  var login_form_state = login_form_stateOpt !== undefined ? login_form_stateOpt : LoginFormUtils$PorterinFeature.getLoginFormStateDefault(undefined);
  var login_form_input = login_form_state.login_form_input;
  var match = CityContext$PorterinFeature.useCitySelectedContext(undefined);
  var match$1 = AuthContextV1$PorterinFeature.useAuthContext(undefined);
  var set_user = match$1.set_user;
  var router = Router.useRouter();
  var match$2 = React.useState(function () {
        return false;
      });
  var setIsSubmitting = match$2[1];
  var match$3 = React.useState(function () {
        return LoginFormState$PorterinFeature.initialFormState(login_form_input);
      });
  var setInitialInput = match$3[1];
  var initialInput = match$3[0];
  var match$4 = React.useState(function () {
        return initialInput.mobile.length === 0;
      });
  var setIsFieldEmpty = match$4[1];
  var match$5 = React.useState(function () {
        
      });
  var setResponse = match$5[1];
  var response = match$5[0];
  var form = LoginFormInterface$PorterinFeature.Form.useForm(initialInput, (function (output, callbacks) {
          LoginFormState$PorterinFeature.onFormSubmit(output, callbacks, setResponse, set_auth_state, router.query, set_user);
        }));
  var getFieldError = function (field) {
    Curry._1(form.dirty, undefined);
    return CommonHelper$PorterinFeature.getError(field);
  };
  React.useEffect((function () {
          var match = form.status;
          var exit = 0;
          if (typeof match === "number") {
            if (match !== /* Editing */0) {
              exit = 1;
            }
            
          } else if (match.TAG === /* Submitting */0) {
            Curry._1(setIsSubmitting, (function (param) {
                    return true;
                  }));
          } else {
            exit = 1;
          }
          if (exit === 1) {
            Curry._1(setInitialInput, (function (param) {
                    return form.input;
                  }));
            Curry._1(form.reset, undefined);
          }
          
        }), [form.status]);
  var match$6 = Curry._1(form.dirty, undefined);
  var tmp;
  tmp = response !== undefined && !(response.TAG === /* Ok */0 || match$6) ? React.createElement("div", {
          className: styles["submit-button-error"]
        }, response._0) : null;
  return React.createElement("form", {
              className: styles["login-form"],
              onSubmit: (function ($$event) {
                  $$event.preventDefault();
                  Curry._1(form.submit, undefined);
                })
            }, React.createElement(AuthInputCmp$PorterinFeature.make, {
                  label: AuthStore$PorterinFeature.Login.form_placeholder,
                  is_required: true,
                  is_filled: match$4[0],
                  children: React.createElement("input", {
                        className: styles["mobile-input"],
                        disabled: form.submitting || login_form_state.is_disabled,
                        maxLength: 10,
                        placeholder: "",
                        type: "tel",
                        value: form.input.mobile,
                        onFocus: (function (param) {
                            Curry._1(set_is_input_in_focus, (function (param) {
                                    return true;
                                  }));
                          }),
                        onBlur: (function (param) {
                            Curry._1(form.blurMobile, undefined);
                          }),
                        onChange: (function ($$event) {
                            Curry._1(setIsFieldEmpty, (function (param) {
                                    return $$event.target.value.length === 0;
                                  }));
                            Curry._2(form.updateMobile, (function (_input, value) {
                                    return {
                                            mobile: value
                                          };
                                  }), $$event.target.value);
                          })
                      }),
                  error: getFieldError(form.mobileResult),
                  styles: styles["input-wrapper"]
                }), React.createElement("div", {
                  className: styles["submit-button-wrapper"]
                }, React.createElement(AuthButtonCmp$PorterinFeature.make, {
                      is_disabled: form.submitting,
                      is_submitting: match$2[0],
                      class_name: styles["submit-container"],
                      event_name: AuthStore$PorterinFeature.Login.ga_form_submit_event,
                      category: match.category,
                      submit_text: AuthStore$PorterinFeature.Login.submit_button,
                      event_label: form.input.mobile,
                      mobile: form.input.mobile
                    }), tmp));
}

var make = LoginFormCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
